import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import 'moment-timezone';
import { compose, graphql } from 'react-apollo';
import Countdown, { zeroPad } from 'react-countdown-now';
import { Link } from 'react-router-dom';
import { SUBSCRIPTION_PREFERRED_LOCATION_CHANGED } from 'containers/DesktopNotificationTray';
import LoadingIndicator from 'components/LoadingIndicator';
import TimeSync from 'utils/TimeSync';
import TimeSyncWrapper from 'utils/TimeSync/TimeSyncWrapper';
import { makeDate } from 'utils/dates';
import { formatDate, formatNumber } from 'utils/formatting';
import WScoreIcon from 'resources/ui-icon-wscore.png';
import { getDateTime } from '../common';
import Prize from '../components/Prize';
import {
  QUERY_GET_AUCTIONS,
  SUBSCRIPTION_AUCTION_EVENT,
  SUBSCRIPTION_AUCTION_UPDATE
} from '../graphql';
import './Lobby.css';

class Pages extends Component {
  componentDidMount() {
    const { auctionsInProgressData, auctionsUpcomingData } = this.props;
    this.unsubscribeFromUpcomingEvents =
      auctionsUpcomingData.subscribeToEvents();
    this.unsubscribeFromUpcomingUpdates =
      auctionsUpcomingData.subscribeToUpdates();
    this.unsubscribeUpcomingFromLocationData =
      auctionsUpcomingData.subscribeToLocationData();
    this.unsubscribeFromInProgressEvents =
      auctionsInProgressData.subscribeToEvents();
    this.unsubscribeFromInProgressUpdates =
      auctionsInProgressData.subscribeToUpdates();
    this.unsubscribeInPogressFromLocationData =
      auctionsInProgressData.subscribeToLocationData();
  }

  componentWillUnmount() {
    this.unsubscribeFromUpcomingEvents();
    this.unsubscribeFromUpcomingUpdates();
    this.unsubscribeUpcomingFromLocationData = () => {};
    this.unsubscribeFromInProgressEvents();
    this.unsubscribeFromInProgressUpdates();
    this.unsubscribeInPogressFromLocationData = () => {};
  }

  handlePageSelect = page => {
    this.setState({ page });
  };

  render() {
    const { auctionsInProgressData, auctionsUpcomingData } = this.props;
    const { loading: auctionsInProgressLoading, data: auctionsInProgress } =
      auctionsInProgressData;
    const { loading: auctionsUpcomingLoading, data: auctionsUpcoming } =
      auctionsUpcomingData;
    const auctions = [...auctionsInProgress, ...auctionsUpcoming];
    auctions.sort((a, b) => getDateTime(a.endTime) - getDateTime(b.endTime));
    let content = null;

    if (auctionsUpcoming.length === 0 && auctionsInProgress.length === 0) {
      content = (
        <div className="empty-auctions-message">
          <span className="auctions-message-header">No Scheduled Auctions</span>
          <span className="auctions-message-text">
            There aren't any Auctions currently scheduled. Keep an eye out for
            future auctions to grab great prizes!
          </span>
        </div>
      );
    } else {
      content = <Page auctions={auctions} />;
    }
    return (
      <div className="auctions-lobby">
        {(auctionsInProgressLoading || auctionsUpcomingLoading) && (
          <LoadingIndicator overlay />
        )}
        {!auctionsInProgressLoading && !auctionsUpcomingLoading && content}
      </div>
    );
  }
}

const Page = ({ auctions }) => {
  return (
    <div className="auctions-page">
      {auctions.map(auction => {
        return (
          <Auction
            key={`${auction.status}-${auction.id}`}
            id={auction.id}
            title={auction.name}
            description={auction.description}
            prizes={auction.prizes.prizes}
            minimumPrice={auction.minimumBid}
            startTime={auction.startTime}
            endTime={auction.endTime}
            status={auction.status}
            bids={auction.bids}
            totalBids={auction.totalBidsCount}
            extendedEndTime={auction.extendedEndTime}
          />
        );
      })}
    </div>
  );
};
class Auction extends Component {
  getCurrentBid(bid, minimumPrice) {
    const titleLabel = bid ? 'Current Bid:' : 'Starting Bid:';
    const bidAmount = bid
      ? formatNumber(bid.amount)
      : formatNumber(minimumPrice);

    return (
      <div className="bid-container">
        <span className="title-bid">{titleLabel}</span>
        <div className="wscore-bid">
          <img src={WScoreIcon} alt="" />
          <span className="wscore-bid-value"> {bidAmount} </span>
        </div>
      </div>
    );
  }

  renderAuctionFooter(id, startTime, hasStarted, extendedEndTime, endTime) {
    const countdownRenderer = ({ days, hours, minutes, seconds }) => {
      const totalHours = days ? days * 24 + hours : hours;
      return `Auction starts: ${zeroPad(totalHours)}:${zeroPad(
        minutes
      )}:${zeroPad(seconds)}`;
    };
    const buttonText = hasStarted ? 'Join' : 'View';

    return (
      <div className="auction-footer">
        <div className="countdown-container">
          {!hasStarted ? (
            <Countdown
              date={TimeSync.toLocalTime(startTime)}
              renderer={countdownRenderer}
            />
          ) : (
            <AuctionCountdown endTime={extendedEndTime || endTime} />
          )}
        </div>
        <Link
          className="auction-button"
          to={{
            pathname: `/auctions/${id}`,
            state: { initiator: 'auction-lobby-join' }
          }}
        >
          {buttonText}
        </Link>
      </div>
    );
  }

  render() {
    const {
      id,
      title,
      description,
      prizes,
      minimumPrice,
      startTime,
      endTime,
      bids,
      totalBids,
      extendedEndTime,
      status
    } = this.props;

    let sortedBids;
    if (bids) {
      sortedBids = [...bids];
      sortedBids.sort((a, b) => a.amount > b.amount);
    }

    const startDateDisplay = formatDate(makeDate(startTime), 'fullCompact');

    const bid = bids && bids.length ? sortedBids[0] : null;
    let hasStarted = status === 'Upcoming' ? false : true;
    return (
      <div className="auction">
        <Prize prizes={prizes} />
        <div className="auction-info">
          <div className="start-date">{startDateDisplay}</div>
          <div className="name">{title}</div>
          <div className="description">{description}</div>
          {this.getCurrentBid(bid, minimumPrice)}
          <div className="bidders">
            {`${totalBids} ${totalBids === 1 ? 'bidder' : 'bidders'}`}
          </div>
          {this.renderAuctionFooter(
            id,
            startTime,
            hasStarted,
            extendedEndTime,
            endTime
          )}
        </div>
      </div>
    );
  }
}

class AuctionCountdown extends Component {
  renderCountdown = ({ days, hours, minutes, seconds }) => {
    const totalHours = days ? days * 24 + hours : hours;
    if (totalHours === 0)
      return (
        <span className="auction-time-remaining-min">{`Auction ends: ${zeroPad(
          minutes
        )}:${zeroPad(seconds)}`}</span>
      );
    return `Auction ends: ${zeroPad(totalHours)}:${zeroPad(minutes)}:${zeroPad(
      seconds
    )}`;
  };

  render() {
    const { endTime } = this.props;
    return (
      <Countdown
        date={TimeSync.toLocalTime(endTime)}
        renderer={this.renderCountdown}
        key={endTime}
      />
    );
  }
}

function getAuctionsGqlConfig({ status }) {
  return {
    name: `auctions${status}Data`,
    options: props => ({
      variables: {
        input: {
          status
        }
      },
      fetchPolicy: 'network-only'
    }),
    props: data => {
      const response = data[`auctions${status}Data`];
      return {
        [`auctions${status}Data`]: {
          ...response,
          data: response.auctions ? response.auctions.auctions : [],
          subscribeToEvents: () => {
            return response.subscribeToMore({
              document: SUBSCRIPTION_AUCTION_EVENT,
              updateQuery: (prev, { subscriptionData }) => {
                const { event, id, ...rest } = subscriptionData.data;
                let result = cloneDeep(prev);

                const auctionToUpdate = result.auctions.auctions.find(
                  item => item.id === id
                );
                if (event === 'start') {
                  if (status === 'Upcoming') {
                    result.auctions.auctions = result.auctions.auctions.filter(
                      item => item.id !== auctionToUpdate.id
                    );
                  }
                  if (status === 'InProgress') {
                    result.auctions.auctions.push({
                      ...rest,
                      __typename: 'Auction',
                      id,
                      status: 'InProgress',
                      winner: null
                    });
                  }
                }

                if (event === 'extend' && auctionToUpdate) {
                  auctionToUpdate.extendedEndTime =
                    subscriptionData.data.extendedEndTime;
                }

                if (event === 'finalize' && auctionToUpdate) {
                  result.auctions.auctions = result.auctions.auctions.filter(
                    item => item.id !== auctionToUpdate.id
                  );
                }

                if (event === 'bid' && auctionToUpdate) {
                  auctionToUpdate.bids = subscriptionData.data.bids;
                  auctionToUpdate.totalBidsCount =
                    subscriptionData.data.totalBidsCount;

                  auctionToUpdate.extendedEndTime =
                    subscriptionData.data.extendedEndTime;
                }

                return result;
              }
            });
          },
          subscribeToUpdates: () => {
            return response.subscribeToMore({
              document: SUBSCRIPTION_AUCTION_UPDATE,
              updateQuery: (prev, { subscriptionData }) => {
                const { event, auctionId: id, ...rest } = subscriptionData.data;
                let result = cloneDeep(prev);

                if (event === 'created') {
                  if (status === 'Upcoming') {
                    result.auctions.auctions.push({
                      ...rest,
                      __typename: 'Auction',
                      id,
                      status: 'Upcoming',
                      winner: null,
                      bids: null,
                      totalBidsCount: null,
                      extendedEndTime: null
                    });
                  }
                }
                if (event === 'updated') {
                  const itemToUpdate = result.auctions.auctions.find(
                    item => item.id === id
                  );
                  result.auctions.auctions[
                    result.auctions.auctions.indexOf(itemToUpdate)
                  ] = {
                    ...itemToUpdate,
                    ...rest
                  };
                }
                if (event === 'deleted') {
                  result.auctions.auctions = result.auctions.auctions.filter(
                    item => item.id !== id
                  );
                }

                return result;
              }
            });
          },
          subscribeToLocationData: () => {
            const { auctionsUpcomingData, auctionsInProgressData } = data;
            if (auctionsUpcomingData) {
              return auctionsUpcomingData.subscribeToMore({
                document: SUBSCRIPTION_PREFERRED_LOCATION_CHANGED,
                updateQuery: () => auctionsUpcomingData.refetch()
              });
            }
            if (auctionsInProgressData) {
              return auctionsInProgressData.subscribeToMore({
                document: SUBSCRIPTION_PREFERRED_LOCATION_CHANGED,
                updateQuery: () => auctionsInProgressData.refetch()
              });
            }
          }
        }
      };
    }
  };
}

const PagesConnected = compose(
  graphql(QUERY_GET_AUCTIONS, getAuctionsGqlConfig({ status: 'Upcoming' })),
  graphql(QUERY_GET_AUCTIONS, getAuctionsGqlConfig({ status: 'InProgress' }))
)(Pages);

export default TimeSyncWrapper(PagesConnected);
